import { render, staticRenderFns } from "./flexibleLayout.vue?vue&type=template&id=6ac443f8&"
import script from "./flexibleLayout.vue?vue&type=script&lang=js&"
export * from "./flexibleLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports